import React from 'react';

import { PATH } from 'src/pages/notification';
import Layout from 'src/components/layout';
import loadable from 'src/utils/loadable';
import { IRouter } from 'src/interfaces/route';
import { t } from 'src/libs/i18n';
import { SCREENS } from 'src/constants/screens';

const NotificationRoute: IRouter[] = [
  {
    element: <Layout />,
    children: [
      {
        path: PATH.NOTIFICATION_SETTING,
        element: loadable(
          () => import('src/pages/notification/NotificationSetting'),
        ),
        title: t('notification_setting.page_title'),
        screenId: SCREENS.R1503,
      },
    ],
  },
];

export default NotificationRoute;
